<style lang="less">
    .pattern {
        .hatch-item .item-preview {
            width: 57px;
        }
        .full {
            width: 100%;
            height: 100%;
            display: block;
        }
        .svgPattern {
            z-index: -1;
            position: absolute;
            top: 0;
            left: 0;
        }
        .last-color-set {
            .last-item {
                margin-bottom: 0;
            }
        }
    }
</style>

<template>
    <div class="pattern">
        <div style="overflow: hidden; position: relative">
            <svg xmlns="http://www.w3.org/2000/svg" ref="svg" class="svgPattern">
                <defs>
                    <pattern id="pat1" width="4" height="4" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dense1'"></iconSymbol>
                    </pattern>
                    <pattern id="pat2" width="4" height="4" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dense2'"></iconSymbol>
                    </pattern>
                    <pattern id="pat3" width="4" height="4" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dense3'"></iconSymbol>
                    </pattern>
                    <pattern id="pat4" width="4" height="4" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dense4'"></iconSymbol>
                    </pattern>
                    <pattern id="pat5" width="4" height="4" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dense5'"></iconSymbol>
                    </pattern>
                    <pattern id="pat6" width="4" height="4" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dense6'"></iconSymbol>
                    </pattern>
                    <pattern id="pat7" width="4" height="4" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dense7'"></iconSymbol>
                    </pattern>
                    <pattern id="pat8" width="8" height="8" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'hor'"></iconSymbol>
                    </pattern>
                    <pattern id="pat9" width="8" height="8" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'ver'"></iconSymbol>
                    </pattern>
                    <pattern id="pat10" width="8" height="8" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'cross'"></iconSymbol>
                    </pattern>
                    <pattern id="pat11" width="8" height="8" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'fdiag'"></iconSymbol>
                    </pattern>
                    <pattern id="pat12" width="8" height="8" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'bdiag'"></iconSymbol>
                    </pattern>
                    <pattern id="pat13" width="8" height="8" patternUnits="userSpaceOnUse" :stroke="foreColor">
                        <iconSymbol :name="'dcross'"></iconSymbol>
                    </pattern>
                </defs>
            </svg>
        </div>
        <div class="rPanel-item hatch-item">
            <span class="left">{{ $t("Pattern.hatch") }}</span>
            <div class="item-dropbox" v-click-outside="closeDirs" @click.stop="toggleDir">
                <div class="item-preview" :style="itemPreview">
                    <svg class="full">
                        <rect width="100%" height="100%" :fill="dirUrl()" />
                    </svg>
                </div>
                <Icon class="ios-arrow" type="ios-arrow-down" />
                <div class="item-downs dir-downs" :style="dirsWCss" v-show="showDir">
                    <div
                        class="item-down dir-down"
                        :style="dirWH"
                        v-for="n in dirNum"
                        :key="n"
                        :class="{ chosenItem: activePatPosIndex === n - 1 }"
                        @click.stop="setDir(n)"
                    >
                        <div :style="itemPreview">
                            <svg class="full">
                                <rect width="100%" height="100%" :fill="dirUrl(n - 1)" />
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ColorSet :type="'Foreground'" :from="fmtType.fill" :fromPaintType="3" :index="0" @changeSet="$emit('changeSet')" />
        <ColorSet class="last-color-set" :type="'Background'" :from="fmtType.fill" :fromPaintType="3" :index="1" @changeSet="$emit('changeSet')" />
    </div>
</template>

<script lang="ts">
    declare var eFmtSetFlag: any;
    enum PatternType {
        NoBrush,
        Solid,
        Dense1,
        Dense2,
        Dense3,
        Dense4,
        Dense5,
        Dense6,
        Dense7,
        Hor,
        Ver,
        Cross,
        FDiag,
        BDiag,
        DCross,
    }
    import ColorSet from "./ColorSet.vue";
    import { Component, Prop, Vue } from "vue-property-decorator";

    @Component({
        components: {
            ColorSet,
        },
    })
    export default class PatternF extends Vue {
        showDir: boolean = false;
        dirL: number = 36; //dir长度 /px;
        dirP: number = 3; //dir的padding /px;

        closeDirs() {
            this.showDir = false;
        }
        toggleDir() {
            this.showDir = !this.showDir;
        }
        setDir(n) {
            window["_view"]._tool.endEdit();
            this.activePatPosIndex = n - 1;
            let view = window["_view"];
            view.setFmt(n - 1, eFmtSetFlag.FillHatchType);
            this.$nextTick(() => {
                this.showDir = false;
            });
            this.$emit("changeSet");
        }
        dirUrl(index: PatternType = this.activePatPosIndex) {
            if (index === PatternType.NoBrush) {
                return this.backColor;
            } else if (index === PatternType.Solid) {
                return this.foreColor;
            } else {
                return "url(#pat" + (index - 1) + ")";
            }
        }
        // activated(){
        //     this.activeThen();
        // }
        activeThen() {
            //svg active pattern force reflow to avoid missing.
            let svgRoot = <SVGElement>this.$refs.svg;
            if (this.activePatPosIndex - 2 < 0) return;
            let activePat = <SVGElement>svgRoot.children[0].children[this.activePatPosIndex - 2];
            activePat.style.display = "none";
            activePat.clientHeight;
            activePat.style.display = null;
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }
        get foreColor() {
            let color = this.$store.state.shape.fillFmt.colors[0];
            if (color === null) {
                color = "#ffffff";
            }
            return color;
        }
        get backColor() {
            let color = this.$store.state.shape.fillFmt.colors[1];
            if (color === null) {
                color = "#000000";
            }
            return color;
        }
        get activePatPosIndex() {
            let index = this.$store.state.shape.fillFmt.patIndex;
            if (index === null) {
                index = 0;
            }
            return index;
        }
        set activePatPosIndex(v: any) {
            let payload = {
                type: "patIndex",
                data: v,
            };
            this.$store.commit("setFillFmtData", payload);
        }
        get dirWH() {
            return {
                width: this.dirL + "px",
                height: this.dirL + "px",
            };
        }
        get dirsWCss() {
            let w: number;
            let h: number;
            w = this.dirsWidth / 3;
            h = 3 * this.dirFullW;
            return {
                width: w + "px",
                height: h + "px",
            };
        }
        get dirFullW() {
            return this.dirL + 2 * this.dirP;
        }
        get dirsWidth() {
            return this.dirNum * this.dirFullW;
        }
        get dirNum() {
            return 15;
        }
        get itemPreview() {
            return {
                backgroundColor: this.backColor,
            };
        }

        mounted() {
            this.activeThen();
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "Pattern": {
      "hatch": "图案"
    }
  },
  "en": {
    "Pattern": {
      "hatch": "Hatch"
    }
  },
  "fr": {
    "Pattern": {
      "hatch": "Hatch"
    }
  },
  "de": {
    "Pattern": {
      "hatch": "Hatch"
    }
  },
  "jp": {
    "Pattern": {
      "hatch": "網掛け"
    }
  },
  "es": {
    "Pattern": {
      "hatch": "Sombreado"
    }
  },
  "pt": {
    "Pattern": {
      "hatch": "Escotilha"
    }
  },
  "it": {
    "Pattern": {
      "hatch": "Tratto"
    }
  },
  "tw": {
    "Pattern": {
      "hatch": "圖案"
    }
  }
}
</i18n>
